import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import { Row, Button, Field, Label, ToolTip, CollapsiblePanel, Paragraph, Tip, Blocker }  from '../../generic'
import TextInput from '../../generic/fields/TextInput'
import RadioInput from '../../generic/fields/RadioInput'
import kit from '../../../images/OTT_Kit.jpg'
import { sharePreferences} from '../../../helpers/enums'
import CopyToClipboardButton from '../../CopyToClipboardButton'
import styled from 'styled-components'
import * as variables from '../../../styles/variables'
import ButtonLinkExternal from '../../generic/ButtonLinkExternal'
import WebMailHelper from '../WebMailHelper'
import checkRequiredFields from '../../../helpers/check-required-fields';
import { STEPS } from '../Step'

export const moment = require('moment')

const ReadOnlyText = styled.div`
  padding: 10px;
  background-color: ${variables.colours.lightGrey};
  border-radius: 5px;
  margin-bottom: 10px;
`

const Segment = styled.div`
  margin-bottom: 32px;
`

class Reminder extends Component {
  render() {
    const { userEvent, currentUser, guests, onChange } = this.props

    let formattedDate = null

    if (userEvent.invitation_date) {
      let dateComponents = userEvent.invitation_date.split("-")

      let date = new Date(dateComponents[0], dateComponents[1]-1, dateComponents[2])
      formattedDate = moment(date).format('dddd MMMM D, YYYY')
    }

    let attendingGuests = [];
    if (guests && guests.length > 0) {
      attendingGuests = guests.filter((guest) => {return guest.status === 'yes';});
    }

    const photoSharingURL = `${process.env.REACT_APP_BASE_URL}/share`

    const message = [
      'Hello!',
      '',
      "Thank you for attending the On the Table event. Your involvement was very much appreciated, and I hope you enjoyed the experience.",
      '',
      "If you have any follow up thoughts, I'd love to hear from you.",
      '',
      'Regards,',
      currentUser.firstname + " " + currentUser.lastname,
      userEvent.organization_name ? userEvent.organization_name : null,
      '',
      "ps. If you'd like to see other On the Tables that took place across BC, or would like to post your own reflections or photos, use #onthetablebc.",
      '',
      "If you have photos that capture the spirit of your gathering that Vancouver Foundation could use in a summary report of On the Table 2019 please upload them here:",
      photoSharingURL,
    ].filter(line => line !== null)

    const thankYouMessage = message.reduce((prev, curr) => { return [...prev, <br/>, curr] }) // Fancy React <br> join.
    const thankYouMessagePlainText = message.join("\n")
    const thankYouMessageMailToText = message.map((line) => encodeURIComponent(line)).join("%0A")

    const blocked = !checkRequiredFields(STEPS['guests'].requiredFields, userEvent, currentUser, {guests: guests})

    return (
      <React.Fragment>
        <h1>Send a Thank You Note</h1>
        <Segment>
          <Paragraph>Use the buttons below to start a thank you email. You can customize the message before sending.</Paragraph>
        </Segment>

        {blocked && 
          <Tip id="thank-you-block" nodismiss="true">
            <p>There are no guests attending yet.</p>
          </Tip>
        }

        <Blocker blocked={blocked}>

          <Segment>
            <h2>Start an email to your guests</h2>
            <WebMailHelper event={userEvent} guests={attendingGuests} body={thankYouMessageMailToText} subject={"Thank You for Attending our On the Table Event!"}/>
          </Segment>

        </Blocker>

      </React.Fragment>
    )
  }
}

export default Reminder

